export default __webpack_public_path__ + "static/media/quick_react_v3_trans.3314ba4c.png";